var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"render-container"},[_c('LivePreview',{attrs:{"text1":_vm.text1,"iconUrl":_vm.iconUrl,"woodType":_vm.woodType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }